import { apiBaseUrl } from './constants'
import moment from 'moment'
// const paymentStatus = { 'status': 'Success', 'data': { 'type': 'Zakah', 'terminal_id': 1, 'status': 'CREATED', 'ps_response': null, 'ps_reference': null, 'id': 11, 'amout': 500 } }

function getHeaders () {
  return new Headers({
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${localStorage.getItem('user-store-token')}`
  })
}
// const emailStatus = {
//   'status': 'Success',
//   'message': 'Email sent successfully'
// }

export default {
  sendEmail ({ donationAmount, donationType, email, userName, paymentId }) {
    return fetch(`${apiBaseUrl}/email/`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify({
        donation_type: donationType,
        donation_amount: donationAmount,
        name: userName,
        email: email,
        donation_date: moment(new Date()).format('DD/MM/YYYY')
      })
    })
    .then(resp => resp.json())
  }
}



// WEBPACK FOOTER //
// ./src/api/email.js